// extracted by mini-css-extract-plugin
export default {"card":"lttjWVfDNkoxaxHDwQYt","icon":"HMLPr8eKLKVxTHEuvDe9","text":"DKHZFr9S_duk9IAAZoEM"};